const TOKEN_NAME_REGEXP = /\$(\w+)\.([\w|/]+)/g;
const UNKNOWN_TOKEN = 'var(--unknown-token)';
export function replaceTokens(definitions, value) {
    if (typeof value !== 'string' || !value.includes('$')) {
        return value;
    }
    return value.replace(TOKEN_NAME_REGEXP, (_match, tokenCategory, tokenName)=>{
        var _definitions_tokenCategory_tokenName, _definitions_tokenCategory;
        const token = definitions === null || definitions === void 0 ? void 0 : (_definitions_tokenCategory = definitions[tokenCategory]) === null || _definitions_tokenCategory === void 0 ? void 0 : (_definitions_tokenCategory_tokenName = _definitions_tokenCategory[tokenName]) === null || _definitions_tokenCategory_tokenName === void 0 ? void 0 : _definitions_tokenCategory_tokenName.toString();
        return token ? `var(${token})` : UNKNOWN_TOKEN;
    });
}

//# sourceMappingURL=replaceTokens.js.map